export default {"src":"__ASTRO_ASSET_IMAGE__BmzH6AH3__","width":1081,"height":669,"format":"jpg"}